import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '@utils/response';
import { errorResponse, okResponse, notFoundResponse } from '@utils/response';
import { Token, UserCode, Company } from '@utils/users';
import * as storage from '@utils/storage';

export function listMenuSupervisor() {
    const param = {};

    param.userCode = UserCode();
    param.token = Token();
    param.company = Company();

    return fetch('supervisor/menu/listMenu', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return new okResponse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listSupervisorFavouritesMenus() {
    return fetch('supervisor/menu/listFavouritesMenus', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function manageSupervisorFavoritesMenus(codeMenu) {
    return fetch('supervisor/menu/manageFavoritesMenus', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCode: UserCode(),
            codeMenu,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

function saveConfig(config) {
    storage.saveMenu(config)
}